import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { LoaderComponent } from './loader/loader.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { ImageSlideshowComponent } from './image-slideshow/image-slideshow.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormFieldComponent } from './ui/form-field/form-field.component';
import { ButtonComponent } from './ui/button/button.component';
import { SvgIconComponent } from './ui/svg-icon/svg-icon.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DisplayTextPipe } from './pipes/display-text.pipe';
import { AmountCurrencyPipe } from './pipes/amount-currency.pipe';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SharedDialogComponent } from './ui/shared-dialog/shared-dialog.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { FilesPreviewerComponent } from './files-previewer/files-previewer.component';
import { FilesDialogPreviewerComponent } from './files-dialog-previewer/files-dialog-previewer.component';
import { PageHeaderComponent } from './ui/page-header/page-header.component';
import { TooltipDirective } from './tooltip/tooltip.directive';
import { AdaptToUserUtcOffsetPipe } from '../core/pipes/adapt-to-user-utc-offset';

@NgModule({
  declarations: [
    LoaderComponent,
    ImageSlideshowComponent,
    AdaptToUserUtcOffsetPipe,
    FilesPreviewerComponent,
    FilesDialogPreviewerComponent,
    TooltipDirective,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatSnackBarModule,
    RouterModule,
    MatCheckboxModule,
    MatDialogModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule,
    MatSelectModule,
    MatFormFieldModule,
    ScrollingModule,
    NgxSkeletonLoaderModule,
    MatDatepickerModule,
    

    DisplayTextPipe,
    AmountCurrencyPipe,
    FormFieldComponent,
    ButtonComponent,
    SvgIconComponent,
    SharedDialogComponent,
    PageHeaderComponent,
    PdfViewerModule,
  ],
  exports: [
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    MatCheckboxModule,
    MatDialogModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    LoaderComponent,
    TranslateModule,
    ImageSlideshowComponent,
    AdaptToUserUtcOffsetPipe,
    MatSelectModule,
    MatFormFieldModule,
    ScrollingModule,
    NgxSkeletonLoaderModule,
    MatDatepickerModule,
    TooltipDirective,

    DisplayTextPipe,
    AmountCurrencyPipe,
    FormFieldComponent,
    ButtonComponent,
    SvgIconComponent,
    SharedDialogComponent,
    PageHeaderComponent,
  ],
})
export class SharedModule {}
